import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'What industries do you serve?',
      answer: 'We serve a wide range of industries including Manufacturing, Retail & E-commerce, Healthcare, Logistics & Distribution, Pharmaceuticals, Automotive, and Food & Beverage. Our solutions are customizable to meet the specific needs of each industry.'
    },
    {
      question: 'How long does implementation typically take?',
      answer: 'Implementation time varies based on the complexity and scale of the project. A basic WMS implementation typically takes 4-8 weeks, while comprehensive solutions with multiple integrations may take 3-6 months. We work closely with your team to minimize disruption to your operations.'
    },
    {
      question: 'Do you provide training for our staff?',
      answer: 'Yes! We provide comprehensive training programs for all users, including hands-on sessions, documentation, video tutorials, and ongoing support. We ensure your team is fully comfortable with the system before going live.'
    },
    {
      question: 'Can your solutions integrate with our existing ERP system?',
      answer: 'Absolutely. Our solutions are designed to integrate seamlessly with popular ERP systems like SAP, Oracle, Microsoft Dynamics, and others. We have extensive experience with API integrations and can work with custom systems as well.'
    },
    {
      question: 'What kind of support do you offer after implementation?',
      answer: 'We provide 24/7 technical support with multiple tiers based on urgency. This includes phone support, email support, remote assistance, on-site support (when needed), regular system health checks, and software updates. We also offer ongoing consultation to help you optimize your operations.'
    },
    {
      question: 'Is your system cloud-based or on-premise?',
      answer: 'We offer both cloud-based and on-premise solutions. Cloud-based solutions provide flexibility, scalability, and lower upfront costs, while on-premise solutions offer complete control and data sovereignty. We can help you choose the best option for your needs.'
    },
    {
      question: 'What hardware is required for your solutions?',
      answer: 'Hardware requirements vary by solution. Common equipment includes barcode scanners, RFID readers, mobile devices, printers, and IoT sensors. We provide detailed hardware recommendations and can supply equipment from trusted vendors, or integrate with your existing hardware.'
    },
    {
      question: 'How do you ensure data security?',
      answer: 'We implement industry-standard security measures including data encryption (at rest and in transit), role-based access control, regular security audits, compliance with ISO standards, secure cloud infrastructure, and regular backups. Data security is a top priority in all our solutions.'
    },
    {
      question: 'Can I get a demo before committing?',
      answer: 'Yes! We offer personalized demos tailored to your specific requirements. Contact us to schedule a demonstration where we\'ll show you how our solutions can address your unique challenges and improve your operations.'
    },
    {
      question: 'What is the typical ROI and how soon can we see results?',
      answer: 'Most clients see measurable improvements within the first 3-6 months, with full ROI typically achieved within 12-18 months. Benefits include reduced labor costs, improved accuracy, faster operations, reduced inventory carrying costs, and better decision-making through real-time data.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-slate-50">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-slate-600">Everything you need to know about our solutions</p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white border-0 shadow-md rounded-lg px-6 hover:shadow-lg transition-shadow duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-lg text-slate-900 hover:text-blue-600 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;